import React from "react";
import styled from "styled-components";

import { ResourceStrings } from "../../../ResourceStrings";
import Modal from "@fluentui/react/lib/Modal";
import Button from "../../shared/Button";
import { RootState } from "../../../store/rootState";
import { Dialog } from "../../../store/appState";
import { useSelector } from "react-redux";
import * as Actions from "../../../store/actions";
import { IconButton } from "@fluentui/react/lib/Button";
import { forMinWidth } from "../../../theme/breakpoints";
import { useHistory } from "react-router-dom";

interface Props {
    answerHubId: number;
    isOpen: boolean;
    communityUrl: string;
    onClose?: () => void;
}

const CommentSubmittedDialog = (props: Props): JSX.Element => {
    const userName = useSelector((state: RootState) => state.appState.userName)
    const history = useHistory();

    const onSeeYourCommentClick = (url: string): void => {
        Actions.clearReportProblem();
        Actions.setDialog(Dialog.none);

        setTimeout(() => {
            history.push(url);
        }, 200);
    }

    return <Modal
        isOpen={props.isOpen}
        isBlocking={false}
        onDismiss={props.onClose}
    >
        <Container role="dialog" aria-label={ResourceStrings.thanksUser(userName)}>
            <div className="title-bar">
                <IconButton
                    title="Close"
                    iconProps={{ iconName: 'Cancel' }}
                    onClick={props.onClose}
                />
            </div>
            <div className="content">
                <div className="text heading" aria-label={ResourceStrings.thanksUser(userName)}>{ResourceStrings.thanksUser(userName)}</div>
                <div className="text" aria-label={ResourceStrings.thanks_SeeYourComment()}>{ResourceStrings.thanks_SeeYourComment()}</div>

                {/* @TODO: link to last comment when DevCom2 has the ability to show comments immediately */}
                <Button onClick={() => onSeeYourCommentClick(props.communityUrl)}><span>{ResourceStrings.thanks_viewDiscussion()}</span>&nbsp;&nbsp;&nbsp;&gt;</Button>
            </div>
        </Container>
    </Modal>
}

export default CommentSubmittedDialog;

const Container = styled.div`
    text-align: center;
    width: auto;
    max-width: 65rem;
    border: 0.1rem solid #3399ff;
    box-shadow: 0.2rem 0.2rem #000000 20% 0.1rem;

    .content {
        padding: 2rem 3rem 5rem;
    }

    ${forMinWidth.md`
        .content {
            padding: 2rem 9rem 5rem;
        }
    `}

    .title-bar {
        display: flex;
        justify-content: flex-end;

        button {
            margin-top: 0;
        }
    }

    button, a {
        margin-top: 2.8rem;
        white-space: nowrap;
    }

    .text {
        line-height: 2.4rem;
    }

    .heading {
        font-size: 2.4rem;
        font-weight: 350;
        margin-bottom: 4rem;
    }

    .sub-heading {
        font-size: 1.4rem;
        margin-top: 1rem;
        margin-bottom: 4rem;
    }
`;
